/** @format */

import axios from "axios";

// Local dev (npm start): REACT_APP_API_URL=http://localhost:5000/api (from .env.development)
// Production Docker build: REACT_APP_API_URL=/api (from docker-compose build arg)
const BASE_URL = process.env.REACT_APP_API_URL || "/api";
const BASE_URL2 = `${BASE_URL}/client`;

export async function fetchAllDamData() {
  try {
    const response = await fetch(`${BASE_URL}/dam`);
    if (!response.ok) throw new Error("Failed to fetch DAM data");
    return await response.json();
  } catch (error) {
    console.error("❌ Error fetching all DAM data:", error);
    return [];
  }
}

export async function fetchDamByDate(date) {
  try {
    const response = await fetch(`${BASE_URL}/dam/${date}`);
    if (!response.ok) throw new Error("No DAM data found for this date");
    return await response.json();
  } catch (error) {
    console.error(`❌ Error fetching DAM data for ${date}:`, error);
    return null;
  }
}

export const fetchAllClients = async () => {
  const res = await axios.get(`${BASE_URL2}/all`);
  return res.data.clients;
};

export const addClientWithInitialMonth = async (client) => {
  return await axios.post(`${BASE_URL2}/settings`, client);
};

export const addMonthToClient = async (data) => {
  return await axios.post(`${BASE_URL2}/settings`, data);
};

export const fetchClientSettings = async (email) => {
  const response = await fetch(
    `${BASE_URL2}/all-settings?email=${encodeURIComponent(email)}`,
  );
  if (!response.ok) throw new Error("Failed to fetch client settings");
  return await response.json();
};

export const loginClient = async (email, password) => {
  const res = await fetch(`${BASE_URL2}/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });
  if (!res.ok) throw new Error("Invalid credentials");
  return res.json();
};
